export function formatDuration(seconds: number): string {
  if (!Number.isFinite(seconds) || seconds <= 0) return '0초'
  const total = Math.floor(seconds)
  const m = Math.floor(total / 60)
  const s = total % 60
  return m === 0 ? `${s}초` : `${m}분 ${s}초`
}

/**
 * 시청시간 등 누적 시간을 `hh:mm:ss` 로 포맷한다(시 단위 롤오버 포함).
 * 예: 0 → "00:00:00", 65 → "00:01:05", 3725 → "01:02:05", 36000 → "10:00:00".
 * NaN/음수/0 이하는 "00:00:00".
 */
export function formatHms(seconds: number): string {
  if (!Number.isFinite(seconds) || seconds <= 0) return '00:00:00'
  const total = Math.floor(seconds)
  const h = Math.floor(total / 3600)
  const m = Math.floor((total % 3600) / 60)
  const s = total % 60
  const pad = (n: number) => n.toString().padStart(2, '0')
  return `${pad(h)}:${pad(m)}:${pad(s)}`
}

const KST_CLOCK = new Intl.DateTimeFormat('en-GB', {
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
  timeZone: 'Asia/Seoul',
})

/**
 * 출결 등 한국 운영 시각을 `HH:mm`(KST)로 포맷한다. 브라우저·OS 시간대와 무관하게 서울 기준으로 찍는다.
 * 입력은 offset(`+09:00`)이나 `Z`가 붙은 ISO 문자열이어야 한다. 비었거나 파싱 불가면 ''.
 */
export function formatKstClockTime(iso: string | null | undefined): string {
  if (!iso) return ''
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return ''
  return KST_CLOCK.format(d)
}
